import Api from '@/api';
import { Http } from '@/utilities/util';

const saveRealtorThirdPartyAcceptance
  = (context, thirdPartyData) => new Promise((resolve, reject) => {
    Api.classicService
      .postRealtorThirdPartyAcceptance(thirdPartyData.userId, thirdPartyData.companyId)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        Http.setGlobalError(
          context,
          Http.createError(error, 'inspection.actions.saveRealtorThirdPartyAcceptance', {
            thirdPartyData,
          }),
        );
        reject();
      });
  });

const copyCrl = (context, data) => new Promise((resolve, reject) => {
  Api.classicService
    .putCopyCrl(data.crlId)
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      Http.setGlobalError(
        context,
        Http.createError(error, 'inspection.actions.copyCrl', data),
      );
      reject();
    });
});

const loadRealtorThirdParty = (context, thirdPartyData) => new Promise((resolve, reject) => {
  Api.classicService
    .getRealtorThirdParty(thirdPartyData.userId, thirdPartyData.companyId)
    .then(response => {
      context.commit('setRealtorThirdParty', response.data);
      resolve(response.data);
    })
    .catch(error => {
      Http.setGlobalError(
        context,
        Http.createError(error, 'inspection.actions.loadRealtorThirdParty', {
          thirdPartyData,
        }),
      );
      reject();
    });
});

export default {
  // saveCustomerThirdPartyAcceptance,
  saveRealtorThirdPartyAcceptance,
  copyCrl,
  // loadConsents,
  // saveConsents,
  // loadCustomerThirdParty,
  loadRealtorThirdParty,
};
